import { render, staticRenderFns } from "./ShiftKeyboardHand.vue?vue&type=template&id=2c490127&scoped=true&"
import script from "./ShiftKeyboardHand.vue?vue&type=script&lang=js&"
export * from "./ShiftKeyboardHand.vue?vue&type=script&lang=js&"
import style0 from "./ShiftKeyboardHand.vue?vue&type=style&index=0&id=2c490127&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c490127",
  null
  
)

export default component.exports